<template>
  <div id="app" class="full-height">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      
    }
  },
  methods:{
    
  }
}
</script>
<style lang="scss">
html {
  // overflow-y: scroll;
}
:root {
  // overflow-y: scroll;
  // overflow-x: hidden;
}
:root body {
  // position: absolute;
  // top:0;
  // bottom:0;
  // overflow-x:hidden;
  // overflow-y:scroll;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb{
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px #aee3fb;
    background-color: #dff0f9;
  }
}
body {
  width: 100vw;
  // overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue